import React from 'react';
import YoutubeEmbed from "./YoutubeEmbed";

export default function Depoimentos() {
    return (
        <section id="depoimentos">
            <div className="container">
                <div className="margin-bottom-20 margin-top-30">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="titulo">Depoimentos</h1>
                        </div>
                    </div>
                    <div className="row margin-bottom-20">
                        <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                            <p className="p-md">
                                Como é fazer parte da <span>Mocidade Espírita?</span>
                            </p>
                            <p className="p-md">
                                Assista no vídeo os depoimentos de alguns alunos e veja o que a <span>Mocidade Espírita</span> representa em suas vidas. <span role="img" aria-label="">❤😍</span>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12">
                            <YoutubeEmbed embedId="aq1_3jgsTJ8" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}